import SC from 'styled-components'
import { IconButton } from 'ui/components/Buttons'

export const Box = SC.footer`
  background: #fff;
  height: 66px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 50px 0 50px;
  border-top: 1px solid ${(p) => p.theme.uiKit.colors.global.grey.grey300};
`

export const DeleteButton = SC(IconButton)`
  margin-right: auto;
`
